/* eslint-disable */
import React from 'react';

const IconMedia25 = (
  <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.4" y="0.4" width="24.2" height="19.2" rx="2.6" stroke="currentColor" strokeWidth="0.8" />
    <path
      d="M10.083 6.25L15.9163 10L10.083 13.75V6.25Z"
      stroke="currentColor"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconMedia25;
